export class PrimerAcceso {
    Nombre: string;
    Login: string;
    Password: string;
    PasswordRepetir: string;
    OldPassword: string;
}


// WEBPACK FOOTER //
// C:/Users/jboix/source/repos/classic/OficinaAngular/src/app/entities/primerAcceso.entity.ts